import styled from "styled-components";

import { DATA_E2E_KEY, type IStyledAttributes } from "@ryde/shared";

export const BooleanImageIconTemplateStyled = styled.div.attrs<IStyledAttributes>(
  {
    [DATA_E2E_KEY]: "boolean-image-icon-template",
  },
)`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  min-height: 42px;
  overflow: visible;

  .BooleanImageIconTemplate-Row {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .BooleanImageIconTemplate-Glyph {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    min-width: 20px;
    font-size: 18px;
    line-height: 1;
    cursor: default;
  }
`;
